import React, { useEffect } from 'react';
import cn from 'classnames/bind';
import { useIntl } from 'react-intl';

import { FullscreenNotification } from '@/shared/components/FullscreenNotification';

import {
    useInfoBlockFullscreenNotificationReactiveVar,
    infoBlockFullscreenNotificationReactiveVar,
} from './hooks/useInfoBlockFullscreenNotificationReactiveVar';
import styles from './styles.module.css';

const cx = cn.bind(styles);

export const InfoBlockFullscreenNotification = () => {
    const intl = useIntl();
    const notification = useInfoBlockFullscreenNotificationReactiveVar();
    useEffect(
        () => () => {
            infoBlockFullscreenNotificationReactiveVar.set(undefined);
        },
        []
    );

    if (!notification) {
        return null;
    }

    const { backgroundImage, foregroundImage, primaryButton } = notification;

    const handleClose = () => {
        infoBlockFullscreenNotificationReactiveVar.set(undefined);
    };

    return (
        <FullscreenNotification
            primaryButtonClassName={cx('primaryButton')}
            backgroundImage={backgroundImage}
            foregroundImage={foregroundImage}
            primaryButtonText={primaryButton.text}
            onPrimaryButtonClick={handleClose}
            onCloseButtonClick={handleClose}
            contentLabel={intl.formatMessage({
                id: 'features.info-blocks.07a3dd247ad6bec7fe401aa11619959f',
                defaultMessage: 'Communication',
                description: 'Подпись для коммуникации',
            })}
            closeButtonText={intl.formatMessage({
                id: 'features.info-blocks.31c2d29fce724b5791c3e8e0203a705c',
                defaultMessage: 'Close communication',
                description: 'Подпись для кнопки закрытия коммуникации',
            })}
        />
    );
};
